module.exports = __webpack_public_path__ + "img/CARDS.10833484.svg";